import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import {
  DownlineHeader,
  LayerUser,
  levelMap,
  toFixedWithoutRounding,
} from "../Utils/Constant";
import { startCase } from "lodash";

const Header = () => {
  const location = useLocation();
  const getCoins = useContextSelector(AuthContext, (ctx) => {
    return ctx.getCoins;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const user_coins = useContextSelector(AuthContext, (ctx) => {
    return ctx.user_coins;
  });
  const isRefereshLoader = useContextSelector(AuthContext, (ctx) => {
    return ctx.isRefereshLoader;
  });
  const logoutUser = useContextSelector(AuthContext, (ctx) => {
    return ctx.logoutUser;
  });

  // ---- Dropdown state (fixes dropdown staying open on mobile) ----
  const [openMenu, setOpenMenu] = useState(null);

  // close any open dropdown when the route changes
  useEffect(() => {
    setOpenMenu(null);
  }, [location.pathname]);

  const dropLi = (name) => ({ className: openMenu === name ? "open" : "" });
  const dropA = (name) => ({
    onClick: () => setOpenMenu((prev) => (prev === name ? null : name)),
  });
  // ----------------------------------------------------------------

  let condition = ["sub_owner", "super_admin", "owner", "admin"].includes(
    user?.userType,
  );
  const canViewSpinReports = [
    "sub_owner",
    "super_admin",
    "agent",
    "admin",
  ].includes(user?.userType);

  return (
    <app-header _ngcontent-serverapp-c45 _nghost-serverapp-c44>
      <div _ngcontent-serverapp-c44 className="top">
        <div _ngcontent-serverapp-c44 className="header">
          <div _ngcontent-serverapp-c44 className="bars hideweb">
            <i
              _ngcontent-serverapp-c44
              aria-hidden="true"
              className="fa fa-bars"
            />
          </div>

          <h1 _ngcontent-serverapp-c44>
            <Link
              _ngcontent-serverapp-c44
              to={`/users/${DownlineHeader(user?.userType)[0]?.layer}`}
            >
              <img
                _ngcontent-serverapp-c44
                src="/assets/images/transparent.gif"
                alt
              />
            </Link>
          </h1>

          <div _ngcontent-serverapp-c44 className="spacer" />

          <ul _ngcontent-serverapp-c44 className="account-wrap">
            <li _ngcontent-serverapp-c44>
              <span
                _ngcontent-serverapp-c44
                className={`Bdlevel ${levelMap[user?.userType]}`}
                style={{ background: "black" }}
              />
              <strong _ngcontent-serverapp-c44 className="lovetextcolor">
                {" "}
                {user?.username}
              </strong>
            </li>
            {isRefereshLoader ? (
              <p _ngcontent-serverapp-c44 className="loading-bar">
                <span _ngcontent-serverapp-c44 />
                <span _ngcontent-serverapp-c44 />
                <span _ngcontent-serverapp-c44 />
                <span _ngcontent-serverapp-c44 />
                <span _ngcontent-serverapp-c44 />
                <span _ngcontent-serverapp-c44 />
                <span _ngcontent-serverapp-c44 />
                <span _ngcontent-serverapp-c44 />
              </p>
            ) : (
              <li _ngcontent-serverapp-c44 className="ng-star-inserted">
                <span _ngcontent-serverapp-c44>Main</span>
                <strong _ngcontent-serverapp-c44 id="mainBalance">
                  {" "}
                  USD {toFixedWithoutRounding(user_coins)}
                </strong>
              </li>
            )}{" "}
            <li
              onClick={() => getCoins()}
              _ngcontent-serverapp-c44
              className="main-wallet no-multi"
            >
              <a
                _ngcontent-serverapp-c44
                id="topRefresh"
                className="a-refresh"
                style={{ cursor: "pointer" }}
              >
                <img
                  _ngcontent-serverapp-c44
                  src="/assets/images/transparent.gif"
                />
              </a>
            </li>
          </ul>
        </div>

        <div _ngcontent-serverapp-c44 className="menu-wrap">
          <div _ngcontent-serverapp-c44 className="main_wrap">
            <ul
              _ngcontent-serverapp-c44
              className="menu"
              onClick={(e) => {
                // close dropdown when any submenu link is clicked
                // (also covers tapping a link to the page you're already on)
                if (e.target.closest("li > ul a")) setOpenMenu(null);
              }}
            >
              {/* Downline */}
              <li _ngcontent-serverapp-c44 {...dropLi("downline")}>
                <a
                  _ngcontent-serverapp-c44
                  id="menu_my_report"
                  className="menu-drop"
                  {...dropA("downline")}
                >
                  Downline{" "}
                </a>

                <ul _ngcontent-serverapp-c44>
                  {DownlineHeader(user?.userType)?.map((res) => {
                    return (
                      <li _ngcontent-serverapp-c44 key={res?.layer}>
                        <Link
                          _ngcontent-serverapp-c44
                          to={`/users/${res?.layer}`}
                        >
                          {startCase(res?.name)}
                        </Link>
                      </li>
                    );
                  })}

                  <li _ngcontent-serverapp-c44>
                    <Link _ngcontent-serverapp-c44 to="/alluser">
                      Search
                    </Link>
                  </li>
                </ul>
              </li>
              {condition && (
                <li _ngcontent-serverapp-c44>
                  <Link
                    _ngcontent-serverapp-c44
                    routerlinkactive="select"
                    id="menu_my_account"
                    to="/setting"
                    className={
                      location?.pathname?.split("/")[1] == "setting"
                        ? "select"
                        : ""
                    }
                  >
                    {" "}
                    Setting
                  </Link>
                </li>
              )}
              <li _ngcontent-serverapp-c44>
                <Link
                  _ngcontent-serverapp-c44
                  routerlinkactive="select"
                  id="menu_my_account"
                  to="/my-account/account-summary"
                  className={
                    location?.pathname?.split("/")[1] == "my-account"
                      ? "select"
                      : ""
                  }
                >
                  {" "}
                  My Account
                </Link>
              </li>

              {/* My Report */}
              <li _ngcontent-serverapp-c44 {...dropLi("report")}>
                <a
                  _ngcontent-serverapp-c44
                  className="menu-drop"
                  id="menu_my_report"
                  {...dropA("report")}
                >
                  {" "}
                  My Report
                </a>

                <ul _ngcontent-serverapp-c44>
                  <li _ngcontent-serverapp-c44>
                    <Link
                      _ngcontent-serverapp-c44
                      to={
                        user?.userType == "agent"
                          ? "/reports/pl-downline/" + user?._id + "/agent"
                          : "/reports/pl-downline"
                      }
                    >
                      Profit/Loss Report by Downline
                    </Link>
                  </li>

                  <li _ngcontent-serverapp-c44>
                    <Link
                      _ngcontent-serverapp-c44
                      to="/reports/parlay-Downline"
                    >
                      Profit/Loss Report by parlay Downline
                    </Link>
                  </li>

                  <li _ngcontent-serverapp-c44>
                    <Link _ngcontent-serverapp-c44 to="/reports/pl-market">
                      Profit/Loss Report by Event
                    </Link>
                  </li>

                  <li _ngcontent-serverapp-c44>
                    <Link _ngcontent-serverapp-c44 to="/reports/pnl-match">
                      Profit/Loss Report by Market
                    </Link>
                  </li>

                  <li _ngcontent-serverapp-c44>
                    <Link _ngcontent-serverapp-c44 to="/reports/pl-player">
                      Profit/Loss Exchange Report by Player
                    </Link>
                  </li>

                  <li _ngcontent-serverapp-c44>
                    <Link
                      _ngcontent-serverapp-c44
                      to="/reports/pnl-casino-downline"
                    >
                      Profit/Loss Report by Casino Downline
                    </Link>
                  </li>

                  <li _ngcontent-serverapp-c44>
                    <Link _ngcontent-serverapp-c44 to="/reports/pnl-downline">
                      Profit/Loss Report by All Casino
                    </Link>
                  </li>

                  <li _ngcontent-serverapp-c44>
                    <Link _ngcontent-serverapp-c44 to="/reports/pl-awccasino">
                      Profit/Loss Report by AWC
                    </Link>
                  </li>
                  {canViewSpinReports && (
                    <>
                      <li _ngcontent-serverapp-c44>
                        <Link
                          _ngcontent-serverapp-c44
                          to="/SpinReport"
                          className={
                            location.pathname === "/SpinReport" ? "select" : ""
                          }
                        >
                          Spin Report
                        </Link>
                      </li>
                      <li _ngcontent-serverapp-c44>
                        <Link
                          _ngcontent-serverapp-c44
                          to="/ActiveSpinReport"
                          className={
                            location.pathname === "/ActiveSpinReport"
                              ? "select"
                              : ""
                          }
                        >
                          Active Spin Report
                        </Link>
                      </li>
                    </>
                  )}
                  {/* <li _ngcontent-serverapp-c44>
                    <Link _ngcontent-serverapp-c44 to="/reports/pl-bogcasino">
                      Profit/Loss Report by BO
                    </Link>
                  </li> */}
                </ul>
              </li>

              <li _ngcontent-serverapp-c44>
                <Link
                  _ngcontent-serverapp-c44
                  routerlinkactive="select"
                  id="menu_bet_list"
                  to="/betList"
                  className={location?.pathname == "/betList" ? "select" : ""}
                >
                  {" "}
                  Bet List
                </Link>
              </li>

              <li _ngcontent-serverapp-c44>
                <Link
                  _ngcontent-serverapp-c44
                  routerlinkactive="select"
                  id="menu_live_bet"
                  to="/betList-live"
                  className={
                    location?.pathname == "/betList-live" ? "select" : ""
                  }
                >
                  {" "}
                  Live Bet
                </Link>
              </li>

              {/* Risk */}
              <li _ngcontent-serverapp-c44 {...dropLi("risk")}>
                <a
                  _ngcontent-serverapp-c44
                  className={`menu-drop ${["/risk-management/riskManagement", "/parlaybetlist"].includes(location?.pathname) ? "select" : ""}`}
                  id="menu_risk"
                  {...dropA("risk")}
                >
                  {" "}
                  Risk
                </a>
                <ul _ngcontent-serverapp-c44>
                  <li _ngcontent-serverapp-c44>
                    <Link
                      _ngcontent-serverapp-c44
                      to="/risk-management/riskManagement"
                    >
                      Risk Management
                    </Link>
                  </li>

                  <li _ngcontent-serverapp-c44>
                    <Link _ngcontent-serverapp-c44 to="/parlaybetlist">
                      Parlay-Bets
                    </Link>
                  </li>
                </ul>
              </li>

              <li _ngcontent-serverapp-c44>
                <Link
                  _ngcontent-serverapp-c44
                  routerlinkactive="select"
                  id="menu_banking"
                  to="/banking"
                  className={location?.pathname == "/banking" ? "select" : ""}
                >
                  {" "}
                  Banking
                </Link>
              </li>

              {/* Casino Control */}
              <li _ngcontent-serverapp-c44 {...dropLi("casino")}>
                <a
                  _ngcontent-serverapp-c44
                  className="menu-drop"
                  id="menu_casino_control"
                  {...dropA("casino")}
                >
                  {" "}
                  Casino Control
                </a>

                <ul _ngcontent-serverapp-c44>
                  <li _ngcontent-serverapp-c44>
                    <Link _ngcontent-serverapp-c44 to="/awcCasino">
                      Awc Casino Bets
                    </Link>
                  </li>
                  {/* 
                  <li _ngcontent-serverapp-c44>
                    <Link _ngcontent-serverapp-c44 to="/bogCasino">
                      Bo Casino Bets
                    </Link>
                  </li> */}
                </ul>
              </li>

              <li _ngcontent-serverapp-c44>
                <Link
                  _ngcontent-serverapp-c44
                  id="menu_block_market"
                  to="/block-market"
                  className={
                    location?.pathname == "/block-market" ? "select" : ""
                  }
                >
                  {" "}
                  Block Market
                </Link>
              </li>
              {condition && (
                <li _ngcontent-serverapp-c44>
                  <Link
                    _ngcontent-serverapp-c44
                    id="menu_block_market"
                    to="/events"
                    className={location?.pathname == "/events" ? "select" : ""}
                  >
                    {" "}
                    MM
                  </Link>
                </li>
              )}

              {/* More */}
              <li _ngcontent-serverapp-c44 {...dropLi("more")}>
                <a
                  _ngcontent-serverapp-c44
                  className="menu-drop"
                  id="menu_more"
                  {...dropA("more")}
                >
                  {" "}
                  More
                </a>

                <ul _ngcontent-serverapp-c44>
                  <li _ngcontent-serverapp-c44>
                    <Link _ngcontent-serverapp-c44 to="/messages/ticker">
                      Ticker
                    </Link>
                  </li>{" "}
                  {["sub_owner", "super_admin"].includes(user?.userType) && (
                    <>
                      <li _ngcontent-serverapp-c44>
                        <Link _ngcontent-serverapp-c44 to="/searchuser">
                          Search User
                        </Link>
                      </li>{" "}
                      <li _ngcontent-serverapp-c44>
                        <Link _ngcontent-serverapp-c44 to="/banner">
                          Banner
                        </Link>
                      </li>{" "}
                      <li _ngcontent-serverapp-c44>
                        <Link _ngcontent-serverapp-c44 to="/manage-links">
                          Manage Links
                        </Link>
                      </li>
                      {user?.allow_domain_access == "yes" && (
                        <li _ngcontent-serverapp-c44>
                          <Link _ngcontent-serverapp-c44 to="/website-setting">
                            Website Setting
                          </Link>
                        </li>
                      )}
                    </>
                  )}
                </ul>
              </li>

              <li _ngcontent-serverapp-c44 className="time_zone">
                <span _ngcontent-serverapp-c44>Timezone :</span> GMT+5:30{" "}
              </li>

              <li
                onClick={() => logoutUser()}
                _ngcontent-serverapp-c44
                className="logout"
              >
                <a href="#" _ngcontent-serverapp-c44 id="logout">
                  Logout
                  <img
                    _ngcontent-serverapp-c44
                    src="/assets/images/transparent.gif"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <app-modal _ngcontent-serverapp-c44 _nghost-serverapp-c43>
        <div
          _ngcontent-serverapp-c43
          id="createModal"
          className="pop_bg"
          style={{ height: "100%", width: "100%", display: "none" }}
        >
          <div _ngcontent-serverapp-c43 className="pop_box pop_refer">
            <a
              _ngcontent-serverapp-c43
              href="#"
              className="close_pop ng-star-inserted"
            >
              close_pop
            </a>

            <div _ngcontent-serverapp-c44 className="modal-header">
              <h3 _ngcontent-serverapp-c44>Confirm Bets</h3>
            </div>
            <div
              _ngcontent-serverapp-c44
              className="modal-content mdclass"
              style={{ "box-shadow": "none" }}
            >
              <p _ngcontent-serverapp-c44>
                {" "}
                Are you sure you want to Unlock bets{" "}
              </p>
            </div>
            <ul _ngcontent-serverapp-c44 className="btn-wrap">
              <li _ngcontent-serverapp-c44>
                <button _ngcontent-serverapp-c44 className="btn">
                  Cancel
                </button>
              </li>
              <li _ngcontent-serverapp-c44>
                <button
                  _ngcontent-serverapp-c44
                  id="Btn"
                  type="submit"
                  className="btn-send"
                  style={{ width: "84px" }}
                >
                  {" "}
                  Unlock{" "}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </app-modal>
      <app-modal _ngcontent-serverapp-c44 _nghost-serverapp-c43>
        <div
          _ngcontent-serverapp-c43
          id="createModal"
          className="pop_bg"
          style={{ height: "100%", width: "100%", display: "none" }}
        >
          <div _ngcontent-serverapp-c43 className="pop_box pop_refer">
            <a
              _ngcontent-serverapp-c43
              href="#"
              className="close_pop ng-star-inserted"
            >
              close_pop
            </a>

            <div _ngcontent-serverapp-c44 className="modal-header">
              <h3 _ngcontent-serverapp-c44>Confirm Transfer</h3>
            </div>
            <div
              _ngcontent-serverapp-c44
              className="modal-content mdclass"
              style={{ "box-shadow": "none" }}
            >
              <p _ngcontent-serverapp-c44>
                {" "}
                Are you sure you want to unlock transfer{" "}
              </p>
            </div>
            <ul _ngcontent-serverapp-c44 className="btn-wrap">
              <li _ngcontent-serverapp-c44>
                <button _ngcontent-serverapp-c44 className="btn">
                  Cancel
                </button>
              </li>
              <li _ngcontent-serverapp-c44>
                <button
                  _ngcontent-serverapp-c44
                  id="Btn"
                  type="submit"
                  className="btn-send"
                  style={{ width: "84px" }}
                >
                  {" "}
                  Unlock{" "}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </app-modal>
      <app-modal _ngcontent-serverapp-c44 _nghost-serverapp-c43>
        <div
          _ngcontent-serverapp-c43
          id="createModal"
          className="pop_bg"
          style={{ height: "100%", width: "100%", display: "none" }}
        >
          <div _ngcontent-serverapp-c43 className="pop_box pop_refer">
            <a
              _ngcontent-serverapp-c43
              href="#"
              className="close_pop ng-star-inserted"
            >
              close_pop
            </a>

            <div _ngcontent-serverapp-c44 className="modal-header">
              <h3 _ngcontent-serverapp-c44>Confirm Restart</h3>
            </div>
            <div
              _ngcontent-serverapp-c44
              className="modal-content mdclass"
              style={{ "box-shadow": "none" }}
            >
              <p _ngcontent-serverapp-c44>
                {" "}
                Are You sure you want restart Games management{" "}
              </p>
            </div>
            <ul _ngcontent-serverapp-c44 className="btn-wrap">
              <li _ngcontent-serverapp-c44>
                <button _ngcontent-serverapp-c44 className="btn">
                  Cancel
                </button>
              </li>
              <li _ngcontent-serverapp-c44>
                <button
                  _ngcontent-serverapp-c44
                  id="Btn"
                  type="submit"
                  className="btn-send"
                  style={{ width: "84px" }}
                >
                  {" "}
                  Restart{" "}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </app-modal>
    </app-header>
  );
};

export default Header;
